import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const SiteFooterLinks = () => {
  const location = useLocation();
  const isLegalPage = location.pathname === '/privacy' || location.pathname === '/terms';
  if (isLegalPage) return null;

  return (
    <div className="site-footer-links" data-testid="site-footer-links">
      <Link to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link>
      <span className="site-footer-dot">&middot;</span>
      <Link to="/terms" data-testid="footer-terms-link">Terms of Service</Link>
    </div>
  );
};

export default SiteFooterLinks;
